import React from 'react';
import { useNavigate } from 'react-router-dom';
import style from './Nav.module.css';
import { useNavigation } from '../../context/NavigationContext ';
import logo  from '../../assets/logo/logo.svg';

export default function Nav() {
  const navigate = useNavigate();
  const { activeMenu, activeSubMenu } = useNavigation();

  const menuStructure = [
    {
      title: '회원 관리',
      items: [
        { label: '회원 조회', path: '/users' }
      ]
    },
    {
      title: '공지사항',
      items: [
        { label: '공지사항 조회', path: '/notices' },
        { label: '공지사항 생성', path: '/notices/create' }
      ]
    },
    {
      title: '최신 필터',
      items: [
        { label: '최신필터 조회', path: '/filters' },
        { label: '최신필터 생성', path: '/filters/create' }
      ]
    }
  ];

  const handleMenuClick = (path) => {
    navigate(path);
  };

  const handleLogoClick = () => {
    navigate('/dashboard');
  };

  const handleLogout = () => {
    console.log('로그아웃');
    navigate('/login');
  };

  return (
    <nav className={style.navigation}>
      <div className={style.navContent}>
        <div className={style.logo} onClick={handleLogoClick} style={{ cursor: 'pointer' }}>
          <div className={style.logoImg}><img src={logo} alt="logo" /></div>
          <div className={style.logoSubText}>관리자 페이지</div>
        </div>

        <div className={style.menuContainer}>
          {menuStructure.map((section, idx) => (
            <div key={idx} className={style.menuSection}>
              <div className={style.menuTitle}>{section.title}</div>
              <ul className={style.menuList}>
                {section.items.map((item, itemIdx) => (
                  <li
                    key={itemIdx}
                    className={`${style.menuItem} ${
                      activeMenu === section.title && 
                      activeSubMenu === item.label ? style.active : ''
                    }`}
                    onClick={() => handleMenuClick(item.path)}
                  >
                    {item.label}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className={style.logout} onClick={handleLogout}>
          로그아웃
        </div>
      </div>
    </nav>
  );
}